import * as React from 'react';
import frequentlyPurchasedServiceInstance from '../../services/products/FrequentlyPurchasedService';
import listService from 'src/services/lists/ListsService';
import './FrequentlyPurchasedProductsCarousel.scss';
import Button from '../common/Button';

import ProductModel from '../../model/product.model';
import ProductCard from '../ProductCard/ProductCard';
import CarouselContainer from '../common/CarouselContainer';
import { analyticsListNames } from 'src/analytics/constant';

import {
  goToFrequentProducts,
  ifLoggedIn,
  goToPartDetail
} from 'src/utils/navigation';
import exploreSmall from '../../assets/explore-small';
import { env } from 'src/shared/env';
import { HalfCircleSpinner } from 'react-epic-spinners';

interface IFrequentlyPurchasedProductsCarouselState {
  isLoading: boolean;
  isFavoriteLoading: boolean;
  selectedFavoriteItem: string;
  products: ProductModel[];
}

export class FrequentlyPurchasedProductsCarousel extends React.Component<
  any,
  IFrequentlyPurchasedProductsCarouselState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      isFavoriteLoading: true,
      selectedFavoriteItem: '',
      products: []
    };
  }

  public handleBuyNow = (productId: string) => {
    const productClicked = this.state.products.find(
      product =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.state.products.indexOf(productClicked) + 1;
    this.props.fireProductClickEvent({
      product: productClicked,
      list: analyticsListNames.FREQUNETLY_PURCHASED
    });
    ifLoggedIn(() => goToPartDetail(productId));
  };

  private getProducts = async () => {
    await frequentlyPurchasedServiceInstance.getProducts().then(res => {
      this.setState({
        isLoading: false,
        isFavoriteLoading: false,
        selectedFavoriteItem:'',
        products: res
      });
      this.fireProductImpressionAnalytics();
    });
  };

  private handleToggleFavorite = (
    name: string,
    category:string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {        
    if (favorite) {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); // Start loading
      listService.deleteItem(favoriteId).then(res => this.getProducts());
    } else {  
      if(category?.trim() === "WSER") {
        goToPartDetail(`${mfc}  ${name}`);
        return;
      }
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name });    
      listService
        .addItem('favorites', name, mfc)
        .then(res => this.getProducts())
        .catch(error => {
          console.error("Failed to add item:", error);
          this.setState({ isFavoriteLoading: false }); // End loading in case of error
        });
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  private viewAll = () => {
    goToFrequentProducts();
  };

  public componentDidMount() {
    this.getProducts();
  }

  private fireProductImpressionAnalytics = () => {
    if (this.props.fireProductImpressionEvent) {
      this.props.fireProductImpressionEvent({
        products: this.state.products,
        list: analyticsListNames.FREQUNETLY_PURCHASED
      });
    }
  };

  public render() {
    const { t } = this.props;
    console.log('this.props.ifLoggedIn', this.props.ifLoggedIn);
    return ifLoggedIn && this.state.isLoading ? (
      <div className="rp-text-container-no-data text-center">
        <HalfCircleSpinner
          color="#0b4da2"
          size={60}
          style={{
            textAlign: 'center',
            display: 'inline-block'
          }}
        />
        <p className="rp-no-data-desc">Loading...</p>
      </div>
    ) : (
      <div className="rp-frequently-purchased-products-carousel">
        <div className="frequently-text">{t('common.frequentlyPurchased')}</div>
        <div>
          {this.state.products.length > 1 ? (
            <Button
              buttonClass="rp-recent-orders--button"
              label={t('recentOrders.viewAll')}
              action={this.viewAll}
            />
          ) : (
            <span />
          )}
        </div>
        {this.state.products.length > 0 ? (
          <CarouselContainer loading={this.state.isLoading}>
            {this.state.products.map((product, index) => (
              <ProductCard
                key={index}
                part={product}
                id={product.productNumber}
                name={product.productNumber}
                category={product.category}
                mfc={product.manufacturerCode}
                description={product.description}
                price={product.partnerPrice}
                msrp={product.retailPrice}
                image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                handleOnClicBuyNow={this.handleBuyNow}
                handleToggleFavorite={this.handleToggleFavorite}
                inStock={product.inStock}
                isFavoriteLoading = {this.state.isFavoriteLoading}
                selectedFavoriteItem = {this.state.selectedFavoriteItem}
                favorite={product.favorite}
                favoriteId={product.idFavoriteItem}
                deal={!!product.discountInfo}
                state={product.state}
                stateDescription={product.stateDescription}
                reloadPart={this.reloadList}
              />
            ))}
          </CarouselContainer>
        ) : (
          // <p className="rp-frequently-purchased-products-carousel--empty">
          //   {t('common.noFrequentPurchasesData')}
          // </p>
          <div className="rp-no-data-container-main rp-frequent-purchased-no-data-container">
            <div className="rp-no-data-container">
              <div className="rp-no-data-text">
                <div className="rp-text-container-no-data">
                  <p className="rp-no-data-desc">
                    {t('common.noFrequentPurchasesData')}
                  </p>
                </div>
              </div>
              <div className="rp-no-data-image-container">
                <img
                  className={
                    env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                      ? 'rp-no-data-img rp-no-data-img-CA'
                      : 'rp-no-data-img'
                  }
                  src={exploreSmall}
                  alt=""
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FrequentlyPurchasedProductsCarousel;
